module.exports = __webpack_public_path__ + "assets/img/scenePic10_app.14e829c9.png";